import featuresStore from './features.store'
import type { FeatureFlag } from './feature-flags'

const isEnabled = (flag: FeatureFlag): boolean => {
  return featuresStore.isEnabled(flag)
}

const isDisabled = (flag: FeatureFlag): boolean => {
  return featuresStore.isDisabled(flag)
}

const isInitialized = (): boolean => {
  return featuresStore.state.initialized
}

export const Features = {
  isEnabled,
  isDisabled,
  isInitialized,
}

export default Features
